module.exports = __webpack_public_path__ + "static/media/Card7.8ee2287f.png";